// Constants
import {
  ARNEO_ECOCONCEPTION_AUDITOR,
  ARNEO_ECOCONCEPTION_USER_EMAIL,
  ARNEO_ECOCONCEPTION_ACCESS_TOKEN,
} from '../../constants';

export default {
  name: 'GoogleSignIn',
  data() {
    return {
      /**
       * The Auth2 parameters, as seen on
       * https://developers.google.com/identity/sign-in/web/reference#gapiauth2initparams.
       * As the very least, a valid client_id must present.
       * @type {Object}
       */
      googleSignInParams: {
        client_id:
          '123938346575-ep11n33orfg211jgvjqcp3q9jumajkao.apps.googleusercontent.com',
        scope:
          'email profile https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.file',
      },
    };
  },
  methods: {
    onSignInSuccess(googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      const basicProfile = googleUser.getBasicProfile();

      localStorage.setItem(ARNEO_ECOCONCEPTION_AUDITOR, basicProfile.getName());
      localStorage.setItem(
        ARNEO_ECOCONCEPTION_USER_EMAIL,
        basicProfile.getEmail(),
      );
      localStorage.setItem(
        ARNEO_ECOCONCEPTION_ACCESS_TOKEN,
        googleUser.getAuthResponse(true).access_token,
      );

      this.$emit('token', {
        type: 'success',
        value: googleUser.getAuthResponse(true).access_token,
      });
    },
    onSignInError(error) {
      // `error` contains any error occurred.
      this.$emit('token', {
        type: 'error',
        value: error && error.message,
      });
    },
  },
  mounted() {
    this.$emit('token');
  },
};
